module.exports = __webpack_public_path__ + "img/icon.9e9424dc.svg";